import { render, staticRenderFns } from "./SummaryPopUp.vue?vue&type=template&id=024d97ae"
import script from "./SummaryPopUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./SummaryPopUp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SummaryPopUp.vue?vue&type=style&index=0&id=024d97ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports